import { transformMessageToChatMessage } from '@/third-party/twilio/chat/transformers/twilioImportTransformer'

class ChatRoom {

    constructor({id, avatarURL, name, users, displayName, otherMember, lastMessage, lastConsumedMessageIndex, archived, unseenMsg, prospectUid, ownerUid, channel, attributes }) {
        if(!channel) throw Error("Specify channel when constructing a room")
        this.id = id;
        this.avatarURL = avatarURL;
        this.name = name;
        this.users = users;
        this.displayName = displayName;
        this.otherMember = otherMember;
        this.lastMessage = lastMessage;
        this.lastConsumedMessageIndex = lastConsumedMessageIndex;
        this.archived = archived;
        this.unseenMsg = unseenMsg;
        this.prospectUid = prospectUid;
        this.ownerUid = ownerUid;
        this.channel = channel;
        this.attributes = attributes 
    }

    getLastConsumedMessageIndex(){
        return this.channel.lastConsumedMessageIndex
    }

    async getMessages(filter){
        if(!this.channel) throw Error("Missing required channel")
        var messagesPag
        if(filter && filter.pageSize > 0){
            messagesPag = await this.channel.getMessages(filter.pageSize, filter.anchor, filter.direction);
        }else{
            messagesPag = await this.channel.getMessages();
        }

        var messages = []
        messagesPag.items?messages = messagesPag.items: void 0;

        while (messagesPag.hasNextPage) {
            messagesPag = await messagesPag.nextPage()
            if(messagesPag.items) messages = messages.concat(messagesPag.items)
        }

        var chatMessages = []
        for (let i = 0; i < messages.length; i++) {
            chatMessages.push(await transformMessageToChatMessage(messages[i]))
        }
        return chatMessages;
    }
}

export default ChatRoom;



// WEBPACK FOOTER //
// ./src/platform/chat/model/ChatRoom.js